import { TypedDocumentString } from '~/modules/graphql/generated/graphql';

class ContentfulGraphqlService {
    private accessToken: string = 'U8tpkupbUcezEsGmJhBr24Hovwq6YNGjZTCgPJAzoXA';
    private spaceId: string = 'z22qpbpjacj0';
    private endpoint: string = `https://graphql.contentful.com/content/v1/spaces/${this.spaceId}/environments/`;

    // Helper: Sends GraphQL requests
    async fetchGraphQL<TData, TVariables>(
        query: TypedDocumentString<TData, TVariables>,
        variables: TVariables,
        environment: string = 'master'
    ): Promise<TData> {
        try {
            const response = await fetch(this.endpoint + environment, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.accessToken}`,
                },
                body: JSON.stringify({ query, variables }),
            });

            const { data, errors } = await response.json();

            if (errors) {
                console.error('GraphQL errors:', errors);
                throw new Error(errors);
            }
            return data;
        } catch (error) {
            console.error('Error fetching GraphQL data:', error);
            throw error;
        }
    }
}

// Singleton-Instanz exportieren
const contentfulService = new ContentfulGraphqlService();

export default contentfulService;
